import { StyleSheet } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    grid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 12,
        justifyContent: 'space-evenly',
        paddingHorizontal: 0,
        paddingVertical: 0,
    },
    // El espaciado entre celdas lo pone `gap` en el contenedor (no margin en %,
    // que por redondeo hacía que la 3ra columna no entrara). El ancho se calcula
    // sobre 3 columnas descontando los 2 gaps de 12 entre ellas.
    cell: {
        width: '30%',
        alignItems: 'center',
    },
    label: {
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 8,
    },
    box: {
        width: '100%',
        height: 44,
        borderRadius: 8,
        paddingHorizontal: 8,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        backgroundColor: theme.colors.inputBackground,
    },
    boxDisabled: {
        color: theme.colors.colorPrimary,
        backgroundColor: undefined,
    },
})

export default styles
